import { viewports } from '@telus-uds/system-constants';
export var getScreenSizes = function () {
    var viewportsMap = viewports.map;
    var viewportAsObject = convertMapToObject(viewportsMap);
    return viewportAsObject;
};
function convertMapToObject(map) {
    var obj = {};
    map.forEach(function (value, key) {
        obj[key] = value;
    });
    return obj;
}
export var breakpoints = getScreenSizes();
var sm = breakpoints.sm, md = breakpoints.md, lg = breakpoints.lg, xl = breakpoints.xl;
export var fromTablet = "(min-width: ".concat(md, "px)"); // 768+
export var fromLaptop = "(min-width: ".concat(lg, "px)"); // 992+
export var fromDesktop = "(min-width: ".concat(xl, "px)"); // 1200+
export var atMobile = "(max-width: ".concat(md - 1, "px)"); // 0 - 767
export var atMobilePortrait = "(max-width: ".concat(sm, "px)"); // 0 - 576
export var atMobileLandscape = "(min-width: ".concat(sm, "px) and (max-width: ").concat(md - 1, "px)"); // 576 - 767
export var atTablet = "(min-width: ".concat(md, "px) and (max-width: ").concat(lg, "px)"); // 768 - 991
export var atXs = "(max-width: ".concat(sm - 1, "px)");
export var atSm = "(min-width: ".concat(sm, "px) and (max-width: ").concat(md - 1, "px)");
export var atMd = "(min-width: ".concat(md, "px) and (max-width: ").concat(lg - 1, "px)");
export var atLg = "(min-width: ".concat(lg, "px) and (max-width: ").concat(xl - 1, "px)");
export var atXl = "(min-width: ".concat(xl, "px)");
export var mediaQueries = {
    xs: atXs,
    sm: atSm,
    md: atMd,
    lg: atLg,
    xl: atXl
};
